/* ============================================================================
   custom-zepto-personalizer.js
   ----------------------------------------------------------------------------
   ALL custom JS for the Zepto Product Personalizer app (the "latch builder").

   Kept in its own file (not in custom.js / custom-fitters.js) on purpose: when
   Zepto is replaced by the in-house builder, delete this file + its <script> in
   snippets/custom-head.liquid + its row in CUSTOMIZATIONS.md and the Zepto code
   is fully gone. Source of truth: this file (the Zepto app's "custom JS" box
   should be empty so it isn't loaded twice).

   What it does (two DOM patches on the personalizer popup, which Zepto builds
   client-side when the shopper clicks "Customize"):
     1. Hides Zepto's redundant "Line N Color" sub-labels.
     2. Rebuilds the "Custom Latch Options" picker as a 3-tile image grid
        (Text / Brand / Logo) and wires the Logo tile to open the custom-logo
        inquiry page in a new tab. (Zepto only knows about Text + Brand; "Logo"
        is an injected pseudo-tile that just links out.)

   How it stays in sync with the popup:
     One rAF-debounced MutationObserver on <html>. It fires whenever the popup is
     inserted or re-rendered (open → close → reopen rebuilds the DOM), runs both
     patches, and both are idempotent + fast-bail once already applied. This
     replaces the original setInterval-poll + DOMContentLoaded-clear scheme,
     which broke once this file loads with `defer` (DOMContentLoaded fires right
     after a defer script, killing the poll before the popup ever existed).

   ⚠️ Better long-term: if the Zepto app lets you (a) attach a thumbnail image to
   each option value and (b) rename/hide option labels — do that in the app and
   delete patches 1 & 2 here. DOM-rewriting via observer is the fallback, not the
   ideal. See CUSTOMIZATIONS.md / the handoff notes.
   ============================================================================ */

(function () {
  if (window.__ntZeptoPersonalizerInit) return;
  window.__ntZeptoPersonalizerInit = true;

  var LATCH_PICKER_SEL = '.pplr-wrapper.pplr-dropdown.pplr-custom-latch-options';
  var LOGO_INQUIRY_URL = 'https://neattools.com/pages/custom-logo-latches-inquiry';

  var TILE_IMAGES = {
    '_pplr_text':      'https://cdn.shopify.com/s/files/1/0568/4812/2044/files/variant-wizard-latchoptions-text-1428056a-63a0-4c1e-9f4c-22c2c93be8db.png?v=1752268797',
    '_pplr_brand':     'https://cdn.shopify.com/s/files/1/0568/4812/2044/files/variant-wizard-latchoptions-brand-21943cca-34ab-4689-89f6-070c15f61e3b.png?v=1752268883',
    '_pplr_logo_link': 'https://cdn.shopify.com/s/files/1/0568/4812/2044/files/variant-wizard-latchoptions-logo-aae71ab5-df02-4dda-9a80-fff056e18eed.png?v=1752268910'
  };

  /* ── Patch 1: hide the "Line N Color" sub-labels ──────────────────────────
     CSS can't target these (no stable class — they're distinguished by text:
     a .pplrlabel whose text contains both "Line" and "Color"), so it's done in
     JS. "Text Color" (no "Line") is intentionally left visible. */
  function hideLineColorLabels() {
    document.querySelectorAll('label.pplrlabel').forEach(function (label) {
      var t = label.textContent;
      if (t.indexOf('Line') !== -1 && t.indexOf('Color') !== -1) {
        label.style.display = 'none';
      }
    });
  }

  /* ── Patch 2: rebuild the latch-options tiles ─────────────────────────────
     Each Zepto option <span class="pplr-drop-item _pplr_xxx"> gets its text
     content swapped for <img> + <div class="dropdown-title">. Idempotent: a tile
     that already has an <img> is skipped. The "Logo" tile is created if missing
     and bound (once) to open the inquiry page. */
  function paintTile(span, imgUrl, titleText) {
    if (!span || span.tagName !== 'SPAN' || span.querySelector('img')) return false;
    var img = document.createElement('img');
    img.src = imgUrl;
    img.alt = titleText;
    img.style.width = 'auto';
    img.style.height = 'auto';
    var title = document.createElement('div');
    title.className = 'dropdown-title';
    title.textContent = titleText;
    span.textContent = '';
    span.appendChild(img);
    span.appendChild(title);
    span.style.padding = '2px';
    return true;
  }

  function buildLatchPicker() {
    var picker = document.querySelector(LATCH_PICKER_SEL);
    if (!picker) return;
    if (picker.querySelector('.pplr-drop-item._pplr_logo_link img')) return; // already done

    paintTile(picker.querySelector('.pplr-drop-item._pplr_text'), TILE_IMAGES._pplr_text, 'Text');

    var brand = picker.querySelector('.pplr-drop-item._pplr_brand');
    paintTile(brand, TILE_IMAGES._pplr_brand, 'Brand');

    var logo = picker.querySelector('.pplr-drop-item._pplr_logo_link');
    if (!logo && brand) {
      logo = document.createElement('span');
      logo.className = 'pplr-drop-item _pplr_logo_link';
      brand.insertAdjacentElement('afterend', logo);
    }
    if (logo) {
      paintTile(logo, TILE_IMAGES._pplr_logo_link, 'Logo');
      logo.style.cursor = 'pointer';
      if (!logo.dataset.ntLogoBound) {
        logo.dataset.ntLogoBound = '1';
        logo.addEventListener('click', function (e) {
          e.preventDefault();
          window.open(LOGO_INQUIRY_URL, '_blank');
        });
      }
    }
  }

  /* ── Run both patches now, then on every DOM change (rAF-coalesced) ─────── */
  function runPatches() {
    hideLineColorLabels();
    buildLatchPicker();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      runPatches();
    });
  }

  runPatches();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
